import { render, staticRenderFns } from "./CreateProductWastePopUp.vue?vue&type=template&id=2026105e&scoped=true&"
import script from "./CreateProductWastePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateProductWastePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductWastePopUp.vue?vue&type=style&index=0&id=2026105e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026105e",
  null
  
)

export default component.exports